import { Button, ButtonProps } from "@chakra-ui/react";
import { EditIcon, SmallCloseIcon } from "@chakra-ui/icons";

type EditButtonProps = ButtonProps & {
  isEditing?: boolean;
};

export default function EditButton({
  children,
  isEditing,
  ...rest
}: EditButtonProps) {
  return (
    <Button
      variant="outline"
      colorScheme="lightPinkButton"
      size="xs"
      textTransform="none"
      leftIcon={isEditing ? <SmallCloseIcon /> : <EditIcon />}
      {...rest}
    >
      {children ?? (isEditing ? "Cancel" : "Edit")}
    </Button>
  );
}
